import { moveSubtitles } from '../Player/utils';
import { selectNormalizedInterval } from '../selectors';

export const SHOW = 'controls/SHOW';
export function show(showControls, isMini, player) {
  moveSubtitles(showControls && !isMini, isMini, player);
  return {
    type: SHOW,
    show: showControls,
  };
}

export const SHOW_MENU = 'controls/SHOW_MENU';
export function showMenu(menuVisible) {
  return {
    type: SHOW_MENU,
    menuVisible,
  };
}

export const SET_SEEKING_TIME = 'controls/SET_SEEKING_TIME';
export function setSeekingTime(time) {
  return (dispatch, getState) => {
    const state = getState();

    const isLive = state.playback.isLive;
    const [start] = selectNormalizedInterval(state);

    const seekingTime = isLive ? start + time : time;

    dispatch({
      type: SET_SEEKING_TIME,
      seekingTime,
    });
  };
}

export const SET_SEEK_MODE = 'controls/SET_SEEK_MODE';
export function setSeekMode(seekMode) {
  return {
    type: SET_SEEK_MODE,
    seekMode,
  };
}
